/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_TitleInputs */

const en_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Merge`)
};

const fr_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusion des métadonnées`)
};

const de_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenzusammenführung`)
};

const it_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unione dei metadati`)
};

const ru_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение метаданных`)
};

const es_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusión de metadatos`)
};

const zh_cn2_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据合并`)
};

const ja_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータのマージ`)
};

const hi_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा मर्ज`)
};

const pt_pt2_metadata_merge_title = /** @type {(inputs: Metadata_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão de metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Merge" |
*
* @param {Metadata_Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_title = /** @type {((inputs?: Metadata_Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_title(inputs)
	if (locale === "de") return de_metadata_merge_title(inputs)
	if (locale === "it") return it_metadata_merge_title(inputs)
	if (locale === "ru") return ru_metadata_merge_title(inputs)
	if (locale === "es") return es_metadata_merge_title(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_title(inputs)
	if (locale === "ja") return ja_metadata_merge_title(inputs)
	if (locale === "hi") return hi_metadata_merge_title(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_title(inputs)
	return en_metadata_merge_title(inputs)
});